var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoutPrimaryIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.483,
    height: 15.483,
    viewBox: "0 0 15.483 15.483",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Logout",
    d: "M12.322,3H15.43a1.554,1.554,0,0,1,1.554,1.554V15.43a1.554,1.554,0,0,1-1.554,1.554H12.322M8.438,13.876l3.884-3.884L8.438,6.107M11.39,9.992H3",
    transform: "translate(-2.25 -2.25)",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoutPrimaryIcon);
export default __webpack_public_path__ + "static/media/logout-primary-icon.0c0d82877362ab614936bc892c01a732.svg";
export { ForwardRef as ReactComponent };